"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ts_validators_1 = require("ts-validators");
const AppStateConstants_1 = require("../types/AppStateConstants");
const appStateCreateStoreWidthoutInitialize_1 = __importDefault(require("./appStateCreateStoreWidthoutInitialize"));
const appStateCreateStore = async (args) => {
    const appStateStore = (0, appStateCreateStoreWidthoutInitialize_1.default)(args);
    const currentLocalDataString = await args.localStorage.getItem(`dbLocalStorage:${args.appId}`);
    const currentLocalData = JSON.parse(currentLocalDataString || '{}');
    appStateStore.dispatch({
        type: AppStateConstants_1.AppStateConstants.LOCAL_STORAGE_SET_DATA,
        payload: currentLocalData,
    });
    const currentDbCacheDataString = await args.localStorage.getItem(`dbCache:${args.appId}`);
    const currentDbCacheData = JSON.parse(currentDbCacheDataString || '[]');
    appStateStore.dispatch({
        type: AppStateConstants_1.AppStateConstants.FIREBASE_REALTIME_DATABASE_SET_CACHE,
        payload: (0, ts_validators_1.valueIsArray)(currentDbCacheData) ? currentDbCacheData : [],
    });
    return appStateStore;
};
exports.default = appStateCreateStore;
